var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 763,
    height: 500,
    viewBox: "0 0 763 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.69 448.257C229.69 448.257 178.208 356.27 91.522 340.422C91.522 340.422 110.594 401.011 185.388 438.569C185.388 438.569 143.292 418.698 93.5785 419.284C93.5785 419.284 122.91 444.591 181.287 452.211C181.287 452.211 107.653 454.923 83.606 474.989H219.568",
    fill: "#5EBDC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.19 267.409C519.389 265.605 512.094 266.249 506.073 269.122C503.201 267.731 499.904 266.766 496.216 266.375C489.38 265.651 483.612 267.26 478.879 269.903C475.041 272.053 470.285 271.214 467.562 267.754C438.575 231.058 387.184 206.648 328.612 206.648C307.093 206.648 286.562 209.981 267.731 215.969C254.358 202.005 232.724 184.915 205.575 182.778C205.575 182.778 193.5 209.418 205.954 250.504C190.214 264.605 178.277 281.43 171.395 299.991L131.769 305.312C127.609 305.312 124.243 322.884 124.243 344.571C124.243 366.257 127.609 383.83 131.769 383.83L181.505 394.254C190.65 408.999 203.185 422.181 218.339 433.122L212.078 475.001H244.19L255.61 453.349C277.6 462.048 302.371 466.967 328.612 466.967C352.981 466.967 376.074 462.715 396.858 455.141L407.324 475.001H439.436L433.703 436.673C469.641 412.803 492.516 376.934 492.516 336.813C492.516 319.31 488.162 302.6 480.269 287.361C477.948 282.867 479.625 277.201 484.256 275.156C487.495 273.73 491.229 272.972 495.469 273.42C496.733 273.558 497.939 273.776 499.054 274.064C498.56 274.558 498.077 275.075 497.617 275.604C492.057 282.097 490.092 290.935 492.757 297.601C494.665 302.382 498.766 305.427 504.017 305.979C504.649 306.048 505.258 306.071 505.867 306.071C513.518 306.071 519.091 300.899 519.952 292.728C520.642 286.223 518.24 279.27 513.093 274.11C516.425 273.305 520.55 273.167 525.605 274.328C527.524 274.776 529.408 273.581 529.844 271.673C530.281 269.765 529.098 267.869 527.19 267.432V267.409ZM512.898 291.969C512.657 294.291 511.335 299.6 504.741 298.922C502.075 298.646 500.26 297.313 499.318 294.969C497.64 290.751 499.145 284.683 502.983 280.201C503.741 279.316 504.752 278.304 506.05 277.351C511.358 281.327 513.38 287.418 512.898 291.969Z",
    fill: "#EF959A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M488.081 366.97C486.588 368.476 450.213 422.732 329.462 425.065C233.631 426.904 180.965 370.717 180.965 370.717C180.965 370.717 136.674 364.074 131.01 362.775C127.161 361.89 124.289 348.467 124.289 348.467V348.49C124.657 368.326 127.874 383.83 131.768 383.83L181.516 394.254C190.662 408.999 203.197 422.181 218.351 433.122L212.089 475.001H244.201L255.621 453.349C277.6 462.06 302.382 466.979 328.612 466.979C352.98 466.979 376.074 462.727 396.858 455.153L407.336 475.001H439.436L433.703 436.684C460.347 418.986 479.809 394.702 488.093 366.982L488.081 366.97Z",
    fill: "#E2BDBC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M389.849 223.439L383.955 240.069C383.955 240.069 358.955 230.139 302.555 233.437L300.119 216.107C310.988 214.463 349.051 210.268 389.849 223.439Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.43 240.057C221.43 240.057 244.764 221.749 267.708 215.957",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.545 344.559C144.545 362.58 141.741 377.199 138.283 377.199C134.825 377.199 132.021 362.591 132.021 344.559C132.021 326.528 134.825 311.92 138.283 311.92C141.741 311.92 144.545 326.528 144.545 344.559Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.575 277.351C235.626 277.351 239.72 272.452 239.72 266.41C239.72 260.367 235.626 255.469 230.575 255.469C225.524 255.469 221.43 260.367 221.43 266.41C221.43 272.452 225.524 277.351 230.575 277.351Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_273_368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 127,
    width: 120,
    height: 111
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M385.966 139.129C385.966 139.129 361.586 130.82 354.015 129.521C346.443 128.222 321.879 127.855 321.879 127.855L293.26 141.933L288.09 198.236L300.119 213.716L302.555 231.047C358.955 227.737 383.955 237.678 383.955 237.678L389.849 221.048C389.849 221.048 407.761 183.088 407.761 182.525C407.761 181.962 385.966 139.118 385.966 139.118V139.129Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_273_368)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M348.363 238.676C375.06 237.725 395.931 215.305 394.98 188.601C394.029 161.896 371.616 141.019 344.92 141.97C318.223 142.921 297.352 165.341 298.303 192.045C299.254 218.75 321.667 239.628 348.363 238.676Z",
    fill: "#E9A134"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "screen"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M381.969 213.182C394.59 193.659 389 167.597 369.483 154.972C349.966 142.347 323.912 147.938 311.291 167.462C298.669 186.985 304.259 213.046 323.777 225.672C343.294 238.297 369.348 232.705 381.969 213.182Z",
    fill: "#E9A134"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M340.698 216.877L341.618 210.418C337.918 209.832 334.253 208.131 332.242 206.223L334.379 202.155C336.459 204.017 339.607 205.695 343.192 206.212C347.73 206.855 351.165 204.672 351.682 201.029C352.176 197.512 349.993 194.984 345.547 192.398C339.4 188.916 335.781 185.41 336.574 179.848C337.321 174.55 341.664 171.056 347.684 170.93L348.603 164.471L352.567 165.034L351.694 171.228C355.508 171.895 357.978 173.297 359.679 174.642L357.484 178.63C356.255 177.676 353.831 175.894 349.74 175.32C344.823 174.619 342.56 177.296 342.192 179.859C341.721 183.181 343.846 185.18 349.086 188.272C355.278 191.892 358.139 195.685 357.323 201.374C356.611 206.419 352.429 210.648 345.696 210.809L344.754 217.452L340.733 216.877H340.698Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M464.264 314.472L481.889 280.672L400.201 260.238L427.166 314.472C427.166 314.472 352.797 369.832 407.542 403.7H483.888C538.634 369.832 464.264 314.472 464.264 314.472Z",
    fill: "#8F93F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M421.708 303.473L423.937 317C423.937 317 446.732 323.149 465.402 315.529L466.034 311.081C456.36 312.231 432.083 308.403 421.708 303.473Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M425.948 316.242L414.47 354.294L428.407 348.168L428.809 315.219",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M458.003 363.465C456.36 361.775 453.832 360.546 450.42 359.787L444.377 358.488C442.607 358.098 441.401 357.592 440.735 356.971C440.068 356.362 439.735 355.569 439.735 354.592C439.735 353.225 440.31 352.11 441.459 351.248C442.607 350.386 444.262 349.949 446.422 349.949C448.076 349.949 449.489 350.099 450.661 350.409C451.833 350.719 452.879 351.099 453.821 351.57C454.751 352.041 455.567 352.213 456.245 352.087C456.923 351.961 457.497 351.65 457.945 351.168C458.394 350.685 458.681 350.11 458.807 349.467C458.934 348.823 458.865 348.168 458.589 347.524C458.313 346.881 457.842 346.341 457.153 345.904C455.889 345.007 454.395 344.306 452.672 343.824C451.466 343.479 450.34 343.261 449.271 343.146V339.859C449.271 338.928 448.961 338.158 448.352 337.56C447.743 336.963 446.985 336.664 446.089 336.664C445.192 336.664 444.377 336.963 443.768 337.56C443.159 338.158 442.849 338.916 442.849 339.859V343.284C440.85 343.605 439.08 344.18 437.529 345.019C435.634 346.042 434.174 347.409 433.129 349.099C432.083 350.788 431.566 352.719 431.566 354.88C431.566 357.649 432.371 359.902 433.991 361.626C435.611 363.35 438.058 364.591 441.332 365.349L447.272 366.648C448.536 366.901 449.524 367.211 450.236 367.59C450.96 367.97 451.466 368.395 451.776 368.889C452.086 369.372 452.235 369.958 452.235 370.647C452.235 371.406 452.006 372.107 451.557 372.751C451.109 373.394 450.386 373.9 449.398 374.233C448.409 374.578 447.065 374.75 445.376 374.75C443.147 374.75 441.252 374.521 439.712 374.049C438.161 373.578 436.955 373.118 436.093 372.647C435.197 372.211 434.404 372.084 433.715 372.245C433.025 372.406 432.463 372.774 432.014 373.348C431.566 373.923 431.302 374.578 431.233 375.291C431.164 376.015 431.279 376.716 431.589 377.394C431.9 378.083 432.44 378.623 433.232 379.014C434.45 379.658 435.99 380.255 437.851 380.796C439.333 381.232 440.999 381.508 442.849 381.634V384.841C442.849 385.737 443.159 386.496 443.768 387.105C444.377 387.714 445.158 388.024 446.089 388.024C447.019 388.024 447.789 387.714 448.386 387.105C448.984 386.496 449.283 385.737 449.283 384.841V381.416C451.259 381.06 453.028 380.462 454.579 379.623C456.417 378.635 457.854 377.325 458.899 375.681C459.945 374.038 460.462 372.176 460.462 370.096C460.462 367.361 459.646 365.143 458.003 363.453V363.465Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382.243 474.989H503.247V457.164H382.243V474.989Z",
    fill: "#E9A134"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.243 474.989H503.247V472.748H382.243V474.989Z",
    fill: "#E9A134"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M494.297 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M482.704 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M471.112 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M459.519 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M447.927 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M436.345 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M424.753 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.16 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M401.568 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M389.975 459.405V472.748",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M266.536 474.76L386.173 456.618L383.502 438.994L263.865 457.136L266.536 474.76Z",
    fill: "#E9A134"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M266.538 474.766L386.175 456.624L385.839 454.409L266.202 472.55L266.538 474.766Z",
    fill: "#E9A134"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M375.017 442.534L377.016 455.728",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M363.551 444.281L365.55 457.463",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M352.096 446.017L354.095 459.21",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M340.63 447.752L342.629 460.945",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M329.175 449.487L331.174 462.681",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M317.709 451.223L319.708 464.416",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M306.254 452.958L308.253 466.152",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M294.788 454.705L296.787 467.887",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M283.333 456.44L285.321 469.634",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M271.867 458.176L273.866 471.369",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M390.217 457.164H511.22V439.339H390.217V457.164Z",
    fill: "#E9A134"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M390.217 457.176H511.22V454.934H390.217V457.176Z",
    fill: "#E9A134"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M502.27 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M490.678 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M479.085 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M467.493 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M455.912 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M444.319 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M432.727 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M421.134 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M409.542 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M397.949 441.58V454.923",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M387.425 439.351H508.429V421.526H387.425V439.351Z",
    fill: "#E9A134"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M387.425 439.339H508.429V437.098H387.425V439.339Z",
    fill: "#E9A134"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M499.49 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M487.898 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M476.305 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M464.713 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M453.12 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M441.527 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M429.935 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M418.342 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M406.75 423.766V437.109",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M395.157 423.767V437.11",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M373.201 421.525H494.205V403.7H373.201V421.525Z",
    fill: "#E9A134"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M373.201 421.525H494.205V419.284H373.201V421.525Z",
    fill: "#E9A134"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M485.255 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M473.662 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M462.081 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M450.489 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M438.896 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M427.304 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M415.711 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M404.119 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M392.526 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M380.934 405.941V419.284",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M475.637 380.471L551.227 474.988L565.142 463.852L489.551 369.336L475.637 380.471Z",
    fill: "#E9A134"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M475.643 380.465L551.234 474.981L552.984 473.581L477.393 379.065L475.643 380.465Z",
    fill: "#E9A134"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M557.786 458.268L547.365 466.6",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M550.548 449.211L540.127 457.544",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M543.298 440.155L532.889 448.487",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M536.06 431.099L525.651 439.443",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M528.822 422.054L518.401 430.386",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M521.572 412.998L511.163 421.33",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M514.334 403.942L503.925 412.274",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M507.096 394.886L496.675 403.218",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M499.858 385.83L489.437 394.173",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M492.608 376.785L482.199 385.117",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M570.16 60.3469C570.16 60.3469 571.849 67.1735 570.458 80.5165C569.057 93.8709 557.372 110.777 557.372 110.777C557.372 110.777 569.034 126.406 603.628 117.27C620.85 112.719 623.596 102.329 623.596 102.329C623.596 102.329 610.521 94.2731 613.256 72.1154",
    fill: "#4A193A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M539.989 157.988C537.508 164.274 536.658 166.78 533.349 175.227C533.349 175.227 503.396 160.31 501.926 158.54C500.972 157.39 498.146 152.977 496.641 150.69C495.159 148.426 490.46 144.116 489.161 143.427C487.289 142.439 486.071 145.369 486.864 146.967C487.656 148.587 488.667 149.874 489.851 151.725L491.206 155.322C491.206 155.322 489.655 154.299 487.806 153.736C486.117 151.725 480.981 146.254 479.832 145.289C477.741 143.553 474.811 145.312 475.374 146.553C475.639 147.139 476.133 148.001 476.673 148.909C475.478 148.093 474.294 147.392 473.295 147.013C472.008 146.53 469.963 147.15 469.63 148.679C467.608 148.277 465.632 149.897 466.769 151.816C465.62 151.771 463.828 152.288 464.598 154.644C465.551 157.574 482.268 166.55 482.268 166.55V166.527C482.463 166.688 482.659 166.86 482.888 166.987C484.462 167.906 490.023 170.009 493.78 170.779C493.78 170.779 515.161 188.938 529.856 199.017C535.612 202.959 546.251 203.533 550.456 197.109C553.73 192.11 563.772 167.722 563.772 167.722C560.36 167.217 549.376 162.321 539.989 157.965V157.988Z",
    fill: "#D97969"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M470.675 149.07C470.675 149.07 476.466 152.61 482.268 156.149",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M467.952 152.403C467.952 152.403 473.743 155.943 479.545 159.482",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M477.017 149.07C477.017 149.07 482.704 152.954 484.244 153.839",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M632.936 425.203L632.397 448.797C632.397 448.797 624.48 456.153 606.603 451.107L603.995 426.674",
    fill: "#D97969"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M632.948 425.203L632.661 437.696C620.597 440.925 610.027 439.787 605.328 438.971L604.018 426.674L632.948 425.203Z",
    fill: "#D97969"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M562.68 419.284L555.396 449.269C555.396 449.269 533.199 452.084 525.72 448.338L529.948 425.157",
    fill: "#D97969"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M562.692 419.284L556.798 443.568C539.805 441.948 531.292 437.937 527.995 435.937L529.959 425.157L562.692 419.284Z",
    fill: "#D97969"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M555.408 449.269C551.903 450.085 543.31 449.441 537.117 448.142C535.957 447.901 534.888 447.66 533.911 447.43L526.961 440.856L519.136 449.51C507.923 452.647 503.603 453.797 494.906 456.222C480.498 460.221 482.785 474.978 482.785 474.978H556.913C562.163 457.67 555.431 449.257 555.431 449.257L555.408 449.269Z",
    fill: "#4D89F5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M552.765 224.243C552.765 224.243 542.62 302.232 538.99 333.377C536.083 354.397 523.606 432.547 523.606 432.547C539.208 440.155 565.61 438.224 565.61 438.224C565.61 438.224 574.997 383.117 578.076 362.43C580.063 347.57 577.926 336.675 577.926 336.675C577.926 336.675 599.089 279.086 597.952 263.398C596.55 244.229 578.374 218.933 578.374 218.933L552.765 224.254V224.243Z",
    fill: "#181E4C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M578.915 333.975L582.511 267.536L597.964 263.445C598.929 277.132 583.062 322.425 578.915 333.975Z",
    fill: "#181E4C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M577.03 222.772L582.338 265.984C582.338 265.984 587.439 313.633 589.542 334.756C591.644 355.845 600.813 435.27 600.813 435.27C623.033 438.224 640.198 432.19 640.198 432.19C640.198 432.19 635.188 385.209 632.833 360.672C630.478 336.135 627.123 331.021 627.123 331.021C627.123 331.021 632.339 271.156 630.145 252.078C627.766 231.38 614.014 218.106 614.014 218.106L577.03 222.772Z",
    fill: "#181E4C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M552.685 124.257C559.946 119.419 579.523 116.281 579.523 116.281L561.325 168.952C557.912 168.446 546.136 165.412 536.83 159.839C543.471 142.623 549.031 126.694 552.685 124.257Z",
    fill: "#4D89F5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M569.241 146.07L561.336 168.952C559.211 168.642 553.857 167.343 547.882 165.079C549.181 157.437 551.26 150.909 551.26 150.909L561.336 145.841L569.241 146.07Z",
    fill: "#181E4C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M551.593 225.278C590.771 228.921 616.082 218.934 616.082 218.934C616.082 218.934 614.577 216.083 612.359 209.28C611.796 207.567 611.199 205.602 610.567 203.384C610.107 201.821 609.797 199.821 609.567 197.58C609.2 193.742 609.085 189.099 609.165 184.456C609.338 174.354 614.335 154.023 614.335 154.023C614.335 154.023 608.717 133.612 601.33 127.636C593.977 121.66 576.421 120.603 576.421 120.603C576.421 120.603 557.211 142.174 552.122 149.047C550.49 151.254 548.882 158.345 555.477 172.837C554.155 195.948 551.57 225.278 551.57 225.278H551.593Z",
    fill: "#4D89F5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M614.359 154.023C614.359 154.023 612.268 162.551 610.739 171.297L608.648 142.921L610.085 141.76C612.739 148.139 614.359 154.023 614.359 154.023Z",
    fill: "#181E4C"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M583.051 134.497C595.826 133.842 602.789 115.627 602.789 115.627C596.516 109.466 600.388 95.0203 600.388 95.0203L585.946 102.33L583.188 103.64C583.188 103.64 582.706 108.731 580.741 113.627C579.949 115.65 578.869 117.638 577.501 119.201C572.791 124.614 570.263 135.141 583.039 134.486L583.051 134.497Z",
    fill: "#D97969"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M580.753 113.627C591.909 110.949 593.816 102.329 593.816 102.329H585.946L583.189 103.64C583.189 103.64 582.706 108.731 580.741 113.627H580.753Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M576.559 108.283C578.984 108.754 590.128 108.329 598.676 97.9048C598.894 97.5485 599.112 97.2382 599.319 96.882C607.695 83.2172 603.237 69.2192 603.237 69.2192C598.469 50.2219 573.618 56.1636 567.759 68.1734L566.552 70.2306C566.552 70.2306 560.969 105.237 576.548 108.283H576.559Z",
    fill: "#D97969"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M548.319 180.445C576.732 218.75 641.013 240.597 641.013 240.597C657.408 219.726 665.761 196.638 665.761 196.638C665.979 194.213 666.289 192.041 666.611 190.512C617.38 179.261 573.285 149.047 573.285 149.047L549.169 174.319L548.319 180.445Z",
    fill: "#50A036"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M641.013 240.597C657.408 219.727 665.761 196.638 665.761 196.638C665.979 194.213 666.29 192.041 666.611 190.512C666.611 190.512 647.562 203.269 647.562 203.66C647.562 204.051 642.208 229.507 641.841 234.472C641.473 239.437 641.002 240.597 641.002 240.597H641.013Z",
    fill: "#50A036"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M574.147 142.921C574.147 142.921 616.289 179.916 666.611 190.512C666.611 190.512 658.27 213.601 641.852 234.472C641.852 234.472 577.582 212.613 549.169 174.319L574.147 142.921Z",
    fill: "#50A036"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M574.147 142.921C574.147 142.921 616.289 179.916 666.611 190.512C666.611 190.512 658.27 213.601 641.852 234.472C641.852 234.472 577.582 212.613 549.169 174.319L574.147 142.921Z",
    fill: "#50A036"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M574.434 145.829L551.743 174.342C577.582 207.901 631.868 228.679 641.14 232.047C653.72 215.681 661.395 198.04 663.831 191.983C620.103 182.019 582.568 152.541 574.422 145.818L574.434 145.829Z",
    fill: "#50A036"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M590.967 182.72C585.774 191.593 588.577 202.913 597.24 208.016C605.903 213.107 617.127 210.038 622.321 201.166C627.514 192.294 624.71 180.973 616.047 175.871C607.385 170.779 596.16 173.848 590.967 182.72Z",
    fill: "#50A036"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M571.504 200.396C572.492 199.821 574.629 198.304 574.629 198.304C574.629 198.304 572.814 197.075 571.504 194.811C570.619 193.271 570.573 190.857 571.332 190.03C572.894 188.34 578.616 193.983 579.971 194.293C581.81 194.707 586.945 195.672 586.945 195.672L618.92 175.79L613.382 152.61C621.413 148.438 631.661 143.806 636.291 141.99C639.439 156.563 645.149 179.962 642.875 185.731C640.243 192.42 612.233 200.798 595.068 206.924C592.483 213.026 584.659 213.681 582.683 214.049C580.282 214.497 577.915 213.337 577.007 211.601C575.307 211.279 573.503 210.636 573.181 208.659C572.147 208.383 569.769 207.027 569.941 205.522C566.61 203.487 568.161 200.833 568.161 200.833C568.161 200.833 570.93 200.695 571.481 200.373L571.504 200.396Z",
    fill: "#D97969"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M614.439 168.401L608.637 142.921L594.93 128.165C597.918 124.315 601.1 119.971 602.789 115.626C602.789 115.626 630.777 122.993 633.27 129.153C635.43 134.486 639.233 149.714 642.013 162.378C634.476 164.033 625.515 166.228 614.439 168.389V168.401Z",
    fill: "#4D89F5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M595.39 57.8531C602.628 54.865 619.333 62.3007 611.303 77.3446C611.532 90.2278 603.651 85.9296 603.651 85.9296C603.651 85.9296 602.088 83.7689 598.848 84.1482C592.748 84.8492 588.048 77.2871 589.703 73.2647C587.279 79.7235 566.495 71.0696 565.76 78.0341C565.76 78.0341 558.223 61.6916 566.173 53.6008C576.238 43.3494 594.551 56.4625 595.39 57.8531Z",
    fill: "#4A193A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M598.906 80.6197C599.584 78.6085 602.789 74.9884 606.822 77.5397C611.705 80.6312 607.603 92.2962 601.801 91.5262C598.216 91.055 597.217 85.6535 598.906 80.6197Z",
    fill: "#D97969"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M636.9 458.083C635.43 451.119 632.396 448.797 632.396 448.797C631.202 449.096 629.961 449.337 628.708 449.533C627.663 447.533 626.215 445.418 625.526 445.074C622.481 443.591 605.569 443.959 605.167 445.269C604.708 446.74 604.214 448.498 603.225 451.613C600.974 452.67 592.552 457.807 590.84 459.991C587.129 464.738 588.784 474.977 588.784 474.977H637.049C637.049 474.977 638.738 466.841 636.889 458.072L636.9 458.083Z",
    fill: "#4D89F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M525.559 171.308L539.518 178.342",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M619.414 175.48C622.332 174.825 627.537 175.514 629.536 177.457",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M570.321 205.349C570.321 205.349 572.159 205.568 574.032 205.188",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M573.561 208.521C573.561 208.521 575.927 208.785 577.272 208.291",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M577.444 211.486C577.444 211.486 579.615 211.601 580.96 211.234",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M605.489 79.5512C600.595 79.1375 598.86 86.6077 602.789 88.4695",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M604.777 81.8382C604.777 81.8382 600.824 81.6428 600.824 86.1134",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M513.899 115.462C520.726 99.3023 513.165 80.6659 497.01 73.8364C480.855 67.0069 462.224 74.5706 455.397 90.7304C448.569 106.89 456.131 125.527 472.286 132.356C488.441 139.186 507.071 131.622 513.899 115.462Z",
    fill: "#8F93F9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M512.933 109.838C516.669 94.1876 507.014 78.4712 491.369 74.7342C475.724 70.9971 460.012 80.6546 456.276 96.3047C452.54 111.955 462.195 127.671 477.84 131.408C493.485 135.145 509.197 125.488 512.933 109.838Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M495.963 104.605C494.458 103.053 492.137 101.927 489 101.237L483.451 100.042C481.831 99.6743 480.717 99.2146 480.108 98.6515C479.499 98.0884 479.189 97.3643 479.189 96.4679C479.189 95.2152 479.717 94.1924 480.774 93.3994C481.831 92.6064 483.348 92.2041 485.335 92.2041C486.852 92.2041 488.15 92.342 489.23 92.6294C490.299 92.9052 491.275 93.2614 492.125 93.6982C492.987 94.1234 493.722 94.2843 494.354 94.1694C494.986 94.0544 495.503 93.7671 495.917 93.3304C496.33 92.8822 496.595 92.365 496.709 91.7674C496.824 91.1698 496.755 90.5722 496.514 89.9861C496.261 89.3884 495.825 88.8943 495.204 88.5035C494.044 87.676 492.677 87.0439 491.091 86.5957C489.988 86.2854 488.943 86.0786 487.966 85.9751V82.9526C487.966 82.0906 487.691 81.3896 487.128 80.8494C486.565 80.3093 485.875 80.0334 485.048 80.0334C484.221 80.0334 483.474 80.3093 482.923 80.8494C482.36 81.3896 482.084 82.1021 482.084 82.9526V86.0901C480.257 86.3889 478.626 86.9175 477.201 87.6875C475.466 88.6299 474.122 89.8826 473.157 91.4341C472.203 92.9856 471.721 94.7555 471.721 96.7437C471.721 99.2836 472.467 101.352 473.95 102.938C475.432 104.524 477.683 105.662 480.694 106.363L486.14 107.558C487.3 107.788 488.208 108.075 488.862 108.42C489.517 108.765 489.988 109.167 490.276 109.615C490.551 110.064 490.701 110.604 490.701 111.224C490.701 111.914 490.494 112.558 490.08 113.155C489.667 113.753 489.012 114.201 488.093 114.523C487.185 114.833 485.956 114.994 484.405 114.994C482.36 114.994 480.625 114.776 479.2 114.35C477.775 113.925 476.672 113.488 475.88 113.063C475.052 112.661 474.329 112.546 473.697 112.695C473.065 112.845 472.548 113.178 472.134 113.707C471.721 114.235 471.479 114.833 471.41 115.488C471.341 116.155 471.456 116.798 471.732 117.419C472.008 118.051 472.513 118.545 473.249 118.901C474.375 119.499 475.788 120.039 477.488 120.533C478.855 120.936 480.383 121.189 482.072 121.303V124.246C482.072 125.073 482.348 125.763 482.911 126.326C483.474 126.889 484.186 127.165 485.037 127.165C485.887 127.165 486.599 126.889 487.139 126.326C487.679 125.763 487.955 125.073 487.955 124.246V121.108C489.77 120.775 491.39 120.235 492.815 119.465C494.504 118.557 495.825 117.35 496.778 115.844C497.732 114.339 498.215 112.627 498.215 110.719C498.215 108.202 497.468 106.179 495.963 104.616V104.605Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M109.948 294.02C119.165 272.055 108.836 246.776 86.8782 237.556C64.9203 228.337 39.6483 238.668 30.4315 260.633C21.2148 282.598 31.5436 307.877 53.5015 317.097C75.4594 326.316 100.731 315.984 109.948 294.02Z",
    fill: "#8F93F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1865 316.919C92.0333 316.919 109.744 299.204 109.744 277.35C109.744 255.497 92.0333 237.781 70.1865 237.781C48.3397 237.781 30.6294 255.497 30.6294 277.35C30.6294 299.204 48.3397 316.919 70.1865 316.919Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5937 279.419C83.5486 277.304 80.4006 275.787 76.1381 274.845L68.6012 273.225C66.4068 272.73 64.8902 272.098 64.063 271.34C63.2358 270.581 62.8222 269.593 62.8222 268.375C62.8222 266.674 63.5345 265.272 64.9706 264.203C66.4068 263.123 68.4748 262.582 71.1633 262.582C73.2313 262.582 74.9892 262.778 76.4483 263.157C77.9074 263.536 79.2172 264.019 80.3891 264.605C81.561 265.191 82.5605 265.398 83.4222 265.249C84.2724 265.088 84.9847 264.709 85.5477 264.099C86.1107 263.49 86.4668 262.789 86.6277 261.973C86.7885 261.169 86.6966 260.353 86.3634 259.548C86.0302 258.744 85.4328 258.066 84.5826 257.526C83.0086 256.399 81.1474 255.537 78.9989 254.928C77.4938 254.503 76.0806 254.227 74.7594 254.078V249.975C74.7594 248.803 74.3803 247.849 73.6105 247.113C72.8522 246.378 71.9101 245.999 70.7841 245.999C69.6582 245.999 68.6472 246.366 67.8889 247.113C67.1306 247.849 66.74 248.803 66.74 249.975V254.239C64.2583 254.641 62.0409 255.354 60.1107 256.411C57.7555 257.687 55.9287 259.387 54.6189 261.491C53.3206 263.605 52.6658 266.007 52.6658 268.696C52.6658 272.156 53.6768 274.96 55.6989 277.109C57.721 279.258 60.7656 280.81 64.8557 281.752L72.2548 283.373C73.8288 283.683 75.0581 284.085 75.9543 284.556C76.8504 285.027 77.4938 285.568 77.8729 286.177C78.2521 286.786 78.4474 287.51 78.4474 288.36C78.4474 289.303 78.1717 290.176 77.6087 290.981C77.0457 291.785 76.1496 292.406 74.9202 292.831C73.6909 293.256 72.0135 293.475 69.911 293.475C67.1306 293.475 64.7753 293.187 62.8451 292.601C60.915 292.015 59.4099 291.429 58.3299 290.854C57.204 290.314 56.2159 290.142 55.3657 290.349C54.5155 290.555 53.8032 291.015 53.2402 291.728C52.6773 292.452 52.3556 293.256 52.2636 294.153C52.1717 295.049 52.3211 295.922 52.7002 296.773C53.0794 297.623 53.7687 298.301 54.7568 298.796C56.2848 299.6 58.2035 300.347 60.5129 301.014C62.3626 301.554 64.4421 301.899 66.74 302.071V306.07C66.74 307.197 67.1191 308.139 67.8889 308.898C68.6472 309.656 69.6123 310.047 70.7841 310.047C71.956 310.047 72.9096 309.668 73.6449 308.898C74.3802 308.139 74.7594 307.185 74.7594 306.07V301.807C77.2296 301.358 79.424 300.611 81.3542 299.577C83.6405 298.347 85.4328 296.704 86.7426 294.658C88.0408 292.613 88.6957 290.291 88.6957 287.694C88.6957 284.28 87.6732 281.522 85.6281 279.408L85.5937 279.419Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M158.883 47.0957H81.0783C74.8092 47.0957 69.7271 52.1794 69.7271 58.4504V110.742C69.7271 117.013 74.8092 122.097 81.0783 122.097H158.883C165.152 122.097 170.234 117.013 170.234 110.742V58.4504C170.234 52.1794 165.152 47.0957 158.883 47.0957Z",
    fill: "#8F93F9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8201 55.1865C91.1082 55.1865 89.7295 53.7959 89.7295 52.095V41.0161C89.7295 39.3037 91.1197 37.9246 92.8201 37.9246C94.532 37.9246 95.9106 39.3152 95.9106 41.0161V52.095C95.9106 53.8074 94.5205 55.1865 92.8201 55.1865Z",
    fill: "#8F93F9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M119.992 55.1865C118.28 55.1865 116.901 53.7959 116.901 52.095V41.0161C116.901 39.3037 118.292 37.9246 119.992 37.9246C121.704 37.9246 123.083 39.3152 123.083 41.0161V52.095C123.083 53.8074 121.692 55.1865 119.992 55.1865Z",
    fill: "#8F93F9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M147.164 55.1865C145.452 55.1865 144.073 53.7959 144.073 52.095V41.0161C144.073 39.3037 145.463 37.9246 147.164 37.9246C148.876 37.9246 150.254 39.3152 150.254 41.0161V52.095C150.254 53.8074 148.864 55.1865 147.164 55.1865Z",
    fill: "#8F93F9",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9026 59.5654H78.8496C77.3648 59.5654 76.1611 60.7695 76.1611 62.2547V72.3107C76.1611 73.796 77.3648 75 78.8496 75H88.9026C90.3874 75 91.5911 73.796 91.5911 72.3107V62.2547C91.5911 60.7695 90.3874 59.5654 88.9026 59.5654Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M112.972 59.5652H102.919C101.435 59.5652 100.231 60.7692 100.231 62.2545V72.3105C100.231 73.7957 101.435 74.9998 102.919 74.9998H112.972C114.457 74.9998 115.661 73.7957 115.661 72.3105V62.2545C115.661 60.7692 114.457 59.5652 112.972 59.5652Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M137.053 59.5652H127C125.516 59.5652 124.312 60.7692 124.312 62.2545V72.3105C124.312 73.7957 125.516 74.9998 127 74.9998H137.053C138.538 74.9998 139.742 73.7957 139.742 72.3105V62.2545C139.742 60.7692 138.538 59.5652 137.053 59.5652Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M161.135 59.5652H151.082C149.597 59.5652 148.394 60.7692 148.394 62.2545V72.3105C148.394 73.7957 149.597 74.9998 151.082 74.9998H161.135C162.62 74.9998 163.823 73.7957 163.823 72.3105V62.2545C163.823 60.7692 162.62 59.5652 161.135 59.5652Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9026 80.4128H78.8496C77.3648 80.4128 76.1611 81.6169 76.1611 83.1021V93.1582C76.1611 94.6434 77.3648 95.8474 78.8496 95.8474H88.9026C90.3874 95.8474 91.5911 94.6434 91.5911 93.1582V83.1021C91.5911 81.6169 90.3874 80.4128 88.9026 80.4128Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M112.972 80.4128H102.919C101.435 80.4128 100.231 81.6169 100.231 83.1021V93.1582C100.231 94.6434 101.435 95.8474 102.919 95.8474H112.972C114.457 95.8474 115.661 94.6434 115.661 93.1582V83.1021C115.661 81.6169 114.457 80.4128 112.972 80.4128Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M137.053 80.4128H127C125.516 80.4128 124.312 81.6169 124.312 83.1021V93.1582C124.312 94.6434 125.516 95.8474 127 95.8474H137.053C138.538 95.8474 139.742 94.6434 139.742 93.1582V83.1021C139.742 81.6169 138.538 80.4128 137.053 80.4128Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M161.135 80.4128H151.082C149.597 80.4128 148.394 81.6169 148.394 83.1021V93.1582C148.394 94.6434 149.597 95.8474 151.082 95.8474H161.135C162.62 95.8474 163.823 94.6434 163.823 93.1582V83.1021C163.823 81.6169 162.62 80.4128 161.135 80.4128Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9026 101.249H78.8496C77.3648 101.249 76.1611 102.453 76.1611 103.938V113.994C76.1611 115.48 77.3648 116.684 78.8496 116.684H88.9026C90.3874 116.684 91.5911 115.48 91.5911 113.994V103.938C91.5911 102.453 90.3874 101.249 88.9026 101.249Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M112.972 101.249H102.919C101.435 101.249 100.231 102.453 100.231 103.938V113.994C100.231 115.48 101.435 116.684 102.919 116.684H112.972C114.457 116.684 115.661 115.48 115.661 113.994V103.938C115.661 102.453 114.457 101.249 112.972 101.249Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M137.053 101.249H127C125.516 101.249 124.312 102.453 124.312 103.938V113.994C124.312 115.48 125.516 116.684 127 116.684H137.053C138.538 116.684 139.742 115.48 139.742 113.994V103.938C139.742 102.453 138.538 101.249 137.053 101.249Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M161.135 101.249H151.082C149.597 101.249 148.394 102.453 148.394 103.938V113.994C148.394 115.48 149.597 116.684 151.082 116.684H161.135C162.62 116.684 163.823 115.48 163.823 113.994V103.938C163.823 102.453 162.62 101.249 161.135 101.249Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M147.164 103.835C150.84 106.11 154.54 111.638 156.447 114.718C156.447 114.718 161.158 105.455 167.787 101.249L163.387 97.9963C163.387 97.9963 159.319 101.823 156.436 109.834C156.436 109.834 152.759 104.8 147.152 103.823L147.164 103.835Z",
    fill: "#DD3D60"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M338.631 83.0791H330.427V114.132H338.631V83.0791Z",
    fill: "#8F93F9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M354.083 92.6179H345.88V114.144H354.083V92.6179Z",
    fill: "#8F93F9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M369.536 79.4817H361.333V114.143H369.536V79.4817Z",
    fill: "#8F93F9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M384.989 69.9658H376.786V114.143H384.989V69.9658Z",
    fill: "#DD3D60"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M388.333 116.626H327.084V117.867H388.333V116.626Z",
    fill: "#8F93F9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M671.161 214.141C712.878 208.28 753.239 236.575 743.968 279.086C733.696 326.137 669.288 325.24 672.103 309.898C674.16 298.704 726.091 313.173 724.459 350.731C722.552 394.874 668.139 398.069 642.174 385.312",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 270.582C117.982 266.41 83.8703 207.2 124.312 164.068C162.445 123.396 225.049 152.61 213.56 166.125C202.392 179.261 170.901 122.2 213.606 90.7105C255.851 59.5655 313.929 92.0552 316.859 139.129",
    stroke: "#0F0E13",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M689.254 457.495C694.378 455.358 696.801 449.47 694.664 444.344C692.528 439.218 686.642 436.794 681.517 438.931C676.393 441.068 673.97 446.956 676.106 452.083C678.243 457.209 684.129 459.632 689.254 457.495Z",
    stroke: "#8F93F9",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1877 192.949C47.8096 192.949 52.3671 188.39 52.3671 182.766C52.3671 177.143 47.8096 172.584 42.1877 172.584C36.5658 172.584 32.0083 177.143 32.0083 182.766C32.0083 188.39 36.5658 192.949 42.1877 192.949Z",
    fill: "#8F93F9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M698.747 253.124C702.795 253.124 706.077 249.842 706.077 245.792C706.077 241.742 702.795 238.46 698.747 238.46C694.698 238.46 691.417 241.742 691.417 245.792C691.417 249.842 694.698 253.124 698.747 253.124Z",
    stroke: "#8F93F9",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M448.639 208.866C454.896 208.866 459.967 203.793 459.967 197.534C459.967 191.276 454.896 186.203 448.639 186.203C442.383 186.203 437.311 191.276 437.311 197.534C437.311 203.793 442.383 208.866 448.639 208.866Z",
    fill: "#8F93F9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M677.124 170.711C686.439 170.711 693.99 163.157 693.99 153.839C693.99 144.522 686.439 136.968 677.124 136.968C667.809 136.968 660.258 144.522 660.258 153.839C660.258 163.157 667.809 170.711 677.124 170.711Z",
    fill: "#8F93F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M671.161 103.076C671.161 107.122 667.886 110.397 663.842 110.397C659.798 110.397 656.523 107.122 656.523 103.076C656.523 99.031 659.798 95.7556 663.842 95.7556C667.886 95.7556 671.161 99.031 671.161 103.076Z",
    fill: "#8F93F9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M159.882 201.476C166.938 201.476 172.658 195.755 172.658 188.697C172.658 181.638 166.938 175.917 159.882 175.917C152.826 175.917 147.106 181.638 147.106 188.697C147.106 195.755 152.826 201.476 159.882 201.476Z",
    stroke: "#8F93F9",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M661.154 427.858C661.154 430.237 659.224 432.168 656.845 432.168C654.467 432.168 652.537 430.237 652.537 427.858C652.537 425.479 654.467 423.548 656.845 423.548C659.224 423.548 661.154 425.479 661.154 427.858Z",
    fill: "#8F93F9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6872 370.464C56.6872 372.843 54.757 374.774 52.3787 374.774C50.0005 374.774 48.0703 372.843 48.0703 370.464C48.0703 368.085 50.0005 366.154 52.3787 366.154C54.757 366.154 56.6872 368.085 56.6872 370.464Z",
    fill: "#8F93F9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M677.124 326.148C677.124 328.527 675.194 330.458 672.815 330.458C670.437 330.458 668.507 328.527 668.507 326.148C668.507 323.769 670.437 321.839 672.815 321.839C675.194 321.839 677.124 323.769 677.124 326.148Z",
    fill: "#8F93F9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M475.282 19.2609C475.282 21.6399 473.352 23.5706 470.974 23.5706C468.596 23.5706 466.666 21.6399 466.666 19.2609C466.666 16.8819 468.596 14.9512 470.974 14.9512C473.352 14.9512 475.282 16.8819 475.282 19.2609Z",
    fill: "#8F93F9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.6045 441.58C86.6045 445.005 83.8357 447.775 80.4119 447.775C76.9881 447.775 74.2192 445.005 74.2192 441.58C74.2192 438.155 76.9881 435.385 80.4119 435.385C83.8357 435.385 86.6045 438.155 86.6045 441.58Z",
    fill: "#8F93F9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M233.815 30.4548C233.815 41.0165 225.256 49.5785 214.697 49.5785C204.139 49.5785 195.579 41.0165 195.579 30.4548C195.579 19.8931 204.127 11.3311 214.697 11.3311C225.267 11.3311 233.815 19.8931 233.815 30.4548Z",
    fill: "#8F93F9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M284.161 72.8164C287.219 72.8164 289.698 70.3363 289.698 67.277C289.698 64.2176 287.219 61.7375 284.161 61.7375C281.102 61.7375 278.623 64.2176 278.623 67.277C278.623 70.3363 281.102 72.8164 284.161 72.8164Z",
    fill: "#8F93F9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M690.44 474.989H17.2217V479.54H690.44V474.989Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M437.724 488.068H638.945",
    stroke: "#0F0E13",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M271.867 488.068H420.18",
    stroke: "#0F0E13",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M127.713 488.068H259.482",
    stroke: "#0F0E13",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingAccount);
export default __webpack_public_path__ + "static/media/saving-account.4229e0dd7a7c97f035c79d52a2796ad1.svg";
export { ForwardRef as ReactComponent };